/**
 * A staff member's booking-calendar link (`yp_users.metadata.calendar`) as
 * the one shape every reader and writer agrees on: an http(s) URL, with the
 * scheme filled in for a bare host. Anything else — `mailto:`, `javascript:`,
 * free text — is not a link and yields `null`.
 *
 * The profile and admin forms validate with it before saving, the API and
 * the typed admin contract refuse what it rejects, and the client dashboard's
 * contact box opens what it returns. One definition, so a value that saves
 * always opens and a value that would not open never saves.
 */
export const normalizeCalendarUrl = (calendar) => {
    if (typeof calendar !== "string")
        return null;
    const value = calendar.trim();
    const isExplicitHttpUrl = /^https?:\/\/[^/]/i.test(value);
    const isSchemeLessHttpHost = /^(?:localhost|(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z](?:[a-z\d-]*[a-z\d])?|(?:\d{1,3}\.){3}\d{1,3}|\[[\da-f:.]+\])(?::\d{1,5})?(?:[/?#]|$)/i.test(value);
    if (!value || (!isExplicitHttpUrl && !isSchemeLessHttpHost)) {
        return null;
    }
    const candidate = isExplicitHttpUrl ? value : `https://${value}`;
    try {
        const url = new URL(candidate);
        return url.hostname &&
            (url.protocol === "http:" || url.protocol === "https:")
            ? url.href
            : null;
    }
    catch {
        return null;
    }
};
/** An empty value clears the link; anything else must normalise to a URL. */
export const isCalendarUrlOrEmpty = (calendar) => calendar.trim() === "" || normalizeCalendarUrl(calendar) !== null;
//# sourceMappingURL=calendar-url.js.map